import * as React from "react";
import * as Scrivito from "scrivito";
import { useProjectDataStore } from "stores/projectStore";
import { useAuthStore } from "stores/authStore";
import cx from "classnames";

export const Logo = Scrivito.connect(({ homepage, imgClass, isConfigLog }) => {
  const isAuthenticated = useAuthStore.use.isAuthenticated();
  if (
    !homepage ||
    !(homepage.get("logo") || homepage.get("configuratorLogo"))
  ) {
    return null;
  }

  const { reset: projDataReset } = useProjectDataStore.getState();

  const logo = isConfigLog
    ? homepage.get("configuratorLogo")
    : homepage.get("logo");

  const logoLink = homepage.get("logoLink");

  const link = logoLink || homepage;

  const onClick = () => {
    projDataReset();
  };

  return (
    <Scrivito.LinkTag
      to={link}
      onClick={onClick}
      className={cx(imgClass, { "cursor-pointer": isAuthenticated })}
    >
      <Scrivito.ImageTag
        content={logo}
        alt="TROX - The art of handling air"
        style={{ minWidth: "126px" }}
      />
    </Scrivito.LinkTag>
  );
});
